
import type {
  BaseErrorResponse,
  CreateInvoiceParamsReq,
  EmptySuccessResponse,
  GetInvoiceListRes,
  GetInvoiceRes,
  InvoiceExportReq,
  UpdateInvoiceParamsReq,
} from './data-contracts';
import type { RequestParams } from './http-client';
import { ContentType, HttpClient } from './http-client';


export default function useInvoice() {
  class Invoice<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Invoice
     * @name InvoiceControllerStartExport
     * @summary Starts export operation
     * @request POST:/api3/invoice/export
     * @secure
     * @response `200` `EmptySuccessResponse`
     * @response `400` `BaseErrorResponse`
     */
    invoiceControllerStartExport = (data: InvoiceExportReq, params: RequestParams = {}) =>
      this.request<EmptySuccessResponse, BaseErrorResponse>({
        path: '/api3/invoice/export',
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Invoice
     * @name InvoiceControllerGetInvoiceList
     * @summary Get a list of invoices
     * @request GET:/api3/invoice
     * @secure
     * @response `200` `GetInvoiceListRes`
     * @response `400` `BaseErrorResponse`
     */
    invoiceControllerGetInvoiceList = (
      query: {
        /**
         * @min 1
         * @max 500
         * @example 10
         */
        limit: number;
        /**
         * @min 0
         * @example 0
         */
        page: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetInvoiceListRes, BaseErrorResponse>({
        path: '/api3/invoice',
        method: 'GET',
        query,
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Invoice
     * @name InvoiceControllerCreateInvoice
     * @summary Create invoice
     * @request POST:/api3/invoice
     * @secure
     * @response `200` `EmptySuccessResponse`
     * @response `400` `BaseErrorResponse`
     */
    invoiceControllerCreateInvoice = (data: CreateInvoiceParamsReq, params: RequestParams = {}) =>
      this.request<EmptySuccessResponse, BaseErrorResponse>({
        path: '/api3/invoice',
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Invoice
     * @name InvoiceControllerUpdateInvoice
     * @summary Update invoice
     * @request PUT:/api3/invoice
     * @secure
     * @response `200` `EmptySuccessResponse`
     * @response `400` `BaseErrorResponse`
     */
    invoiceControllerUpdateInvoice = (data: UpdateInvoiceParamsReq, params: RequestParams = {}) =>
      this.request<EmptySuccessResponse, BaseErrorResponse>({
        path: '/api3/invoice',
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Invoice
     * @name InvoiceControllerGetInvoice
     * @summary Get invoice
     * @request GET:/api3/invoice/{invoiceId}
     * @secure
     * @response `200` `GetInvoiceRes`
     * @response `400` `BaseErrorResponse`
     */
    invoiceControllerGetInvoice = (invoiceId: number, params: RequestParams = {}) =>
      this.request<GetInvoiceRes, BaseErrorResponse>({
        path: `/api3/invoice/${invoiceId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      });
  }

  return new Invoice();
}
